"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";
import { Check, X } from "lucide-react";
import { useToastStore } from "@/store/toast.store";

const DURATION = 3000;

export function Toast() {
  const { message, linkLabel, linkHref, hide } = useToastStore();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!message) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(hide, DURATION);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [message, hide]);

  if (!message) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] max-w-[calc(100vw-3rem)] animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="flex items-center gap-3 rounded-2xl border border-gray-200 dark:border-[#313131] bg-white dark:bg-[#2A2A2A] px-5 py-3.5 text-sm text-gray-900 dark:text-white shadow-xl">
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary">
          <Check className="h-3.5 w-3.5 text-secondary" strokeWidth={3} />
        </span>
        <span className="font-medium">{message}</span>
        {linkLabel && linkHref && (
          <Link
            href={linkHref}
            onClick={hide}
            className="font-bold text-secondary dark:text-primary underline-offset-2 whitespace-nowrap hover:underline transition-colors"
          >
            {linkLabel}
          </Link>
        )}
        <button
          onClick={hide}
          aria-label="Fermer"
          className="ml-1 rounded-full p-0.5 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
        >
          <X className="h-3.5 w-3.5" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
